import angular from 'angular';
import bySearchModule from './by-search/by-search';
import byFavoritesModule from './by-favorites/by-favorites';
import byLastItemsModule from './by-last-items/by-last-items';

let fastPurchaseModule = angular.module('app.fastPurchase', [
    bySearchModule.name,
    byFavoritesModule.name,
    byLastItemsModule.name
]);

export default fastPurchaseModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/fast-purchase/fast-purchase.js
 **/